"use strict";

angular.module("customer")
.factory("VendorsListService", function($resource, $stateParams, appConfig) {
    return {
        queryVendors: function( page) {
            var service = $resource(appConfig.API_SERVER + "/catalog/customer/vendors/", {
                search: $stateParams.search,
                product_category: $stateParams.categories,
                page: page
            }, {
                query: {method: "get"}
            });
            return service.query();
        },
        queryVendorCatalogs: function(vendorId) {
            var service = $resource(appConfig.API_SERVER + "/catalog/customer/vendor-catalogs/", {
                vendor: vendorId
            }, {
                query: {
                    method: "get",
                    isArray: true
                }
            });
            return service.query();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/vendors-list/vendor-list.service.js
// module id = 815
// module chunks = 0